import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import Checkbox from './inputs/Checkbox';
import TenantProp from '../propTypes/tenantProp';
import ConfigsContext from '../../contextProviders/ConfigsContext';

const checkboxLabel = (t, tenant) => {
  const { branding, terms } = tenant;
  const { organization } = useContext(ConfigsContext);
  const { appName } = branding;
  const { termsLink: tenantTermsLink, privacyLink: tenantPrivacyLink } = terms;
  const termsLink = organization?.termsAndConditions ? '/privacy-policy' : tenantTermsLink;
  const privacyLink = organization?.privacyPolicy ? '/terms-and-conditions' : tenantPrivacyLink;

  const handleClick = (event, navigationLink) => {
    event.stopPropagation(); // Stops the event from propagating
    event.preventDefault(); // Prevents the default action (navigation)
    window.open(navigationLink, '_blank');
  };
  return (
    <div className="signUp-checkbox">
      <span>{t('complete.registration.accepting.terms', appName)}</span>
      <button
        type="button"
        className="button-privacy-terms-links"
        onClick={e => handleClick(e, termsLink)}
      >
        {` ${t(
          'complete.registration.accepting.terms.app.termsOfUse',
          appName,
        )}. `}
      </button>
      <span>
        {t('complete.registration.accepting.terms.privacyPolicy', appName)}
      </span>
      <button
        type="button"
        className="button-privacy-terms-links"
        onClick={e => handleClick(e, privacyLink)}
      >
        {` ${t(
          'complete.registration.accepting.terms.app.privacyPolicy',
          appName,
        )}.`}
      </button>
    </div>
  );
};

const TermsAndPolicyCheckbox = props => {
  const { t, tenant, checkboxValue, handleCheckbox } = props;

  return (
    <div className="checkbox-signUp-wrapper">
      <Checkbox
        id="terms"
        value={checkboxValue}
        onChange={handleCheckbox}
        label={checkboxLabel(t, tenant)}
      />
    </div>
  );
};

TermsAndPolicyCheckbox.propTypes = {
  t: PropTypes.func.isRequired,
  tenant: PropTypes.shape(TenantProp.propType).isRequired,
  checkboxValue: PropTypes.bool.isRequired,
  handleCheckbox: PropTypes.func.isRequired,
};
TermsAndPolicyCheckbox.defaultProps = {};

export default translate(TermsAndPolicyCheckbox);
